import { useTranslation } from "react-i18next"
import { observer } from "mobx-react-lite"
import React, { ReactNode } from "react"
import { useParams } from "../stores/uiStore"
import { useStore } from "../contexts/store"

import AccountButton from "./Header/AccountButton"
import PodImageHeader from "./Pod/PodImageHeader"
import Search from "./Elements/Search"
import Sidebar from "./Sidebar"

import { useSwipeable } from "react-swipeable"
import { Box, Button, Drawer, ListItemIcon, ListItemText, Menu, MenuItem, Theme } from "@mui/material"
import MenuIcon from '@mui/icons-material/Menu'
import MenuOpenIcon from '@mui/icons-material/MenuOpen'
import SyncStatus from "./Header/SyncStatus"
import { ArrowBack, ArrowRightOutlined, Description, DescriptionOutlined, FileOpenOutlined, Folder, FolderOpen, FolderOpenOutlined, FolderOutlined } from "@mui/icons-material"
import { MaterialListType } from "../classes/Pod"
import { navigate } from "wouter/use-browser-location"


















const PdfPath = () => {
  const { podStore } = useStore()
  const { podId, tab, nodeId } = useParams()
  const pod = podStore.pod
  const [fileMenuAnchorEl, setFileMenuAnchorEl] = React.useState<null | HTMLElement>(null)
  const [folderMenuAnchorEl, setFolderMenuAnchorEl] = React.useState<null | HTMLElement>(null)
  const fileMenuOpen = Boolean(fileMenuAnchorEl)
  const folderMenuOpen = Boolean(folderMenuAnchorEl)

  if (pod && podId && nodeId && tab === 'pdf') {
     const buttonStyle = {
      overflow:'hidden',
      whiteSpace:'nowrap',
      verticalAlign:'middle',
      textTransform:'none',
      color: (theme:Theme) => theme.palette.textcolor.light,
      fontSize:'small'
    }

    const folderButton = (pod?.content.pdfFiles[nodeId].folderId) ? <Button onClick={(event) => setFolderMenuAnchorEl(event.currentTarget)} sx={buttonStyle} startIcon={<FolderOpen />}>
      {pod?.content.folders[pod?.content.pdfFiles[nodeId].folderId].name}
    </Button> : <Button onClick={(event) => setFolderMenuAnchorEl(event.currentTarget)} sx={buttonStyle} startIcon={<FolderOpen />}>.</Button>

    const filesList = pod.getPdfFilesWithFolderId(pod?.content.pdfFiles[nodeId].folderId || "").filter((f:MaterialListType) => ( !pod.nodeIsHiddenForThisUser(f.id) ) )
    filesList.sort((a: any, b: any) => {
      if(a.weight < b.weight) return -1
      if(a.weight > b.weight) return 1
      return 0
    })

    const handleFileMenuClose = () => { setFileMenuAnchorEl(null) }
    const fileMenu = <Menu
      id="file-menu"
      anchorEl={fileMenuAnchorEl}
      open={fileMenuOpen}
      onClose={handleFileMenuClose}
      slotProps={{
          list: {
            dense: true, // 'aria-labelledby': buttonId,
          },
      }}
    >
      {filesList.map(e => <MenuItem selected={e.file?.nodeId === nodeId} onClick={() => { navigate(`/pod/${podId}/pdf/${e.file?.nodeId}`); handleFileMenuClose()}}>
        <ListItemIcon>
          {e.file?.nodeId === nodeId ? <Description fontSize="small" /> : <DescriptionOutlined fontSize="small" />}
        </ListItemIcon>
        <ListItemText>{e.file?.name}</ListItemText>
      </MenuItem>)}
    </Menu>


    const handleFolderMenuClose = () => { setFolderMenuAnchorEl(null) }
    const firstFile = pod.getPdfFilesWithFolderId('').filter((f:MaterialListType) => ( !pod.nodeIsHiddenForThisUser(f.id) ) )[0]
    const folderMenu = <Menu
      id="file-menu"
      anchorEl={folderMenuAnchorEl}
      open={folderMenuOpen}
      onClose={handleFolderMenuClose}
      slotProps={{
          list: {
            dense: true, // 'aria-labelledby': buttonId,
          },
      }}
    >
      <MenuItem selected={'' === pod?.content.pdfFiles[nodeId].folderId} onClick={() => { navigate(`/pod/${podId}/pdf/${firstFile.file?.nodeId}`); handleFolderMenuClose()}} disabled={!firstFile}>
          <ListItemIcon>
            {'' === pod?.content.pdfFiles[nodeId].folderId ? <FolderOpen fontSize="small" /> : <FolderOutlined fontSize="small" />}
          </ListItemIcon>
          <ListItemText>.</ListItemText>
        </MenuItem>
      {pod.getFolders().filter(f => !pod.nodeIsHiddenForThisUser(f.folderId)).map((folder) => {
        const firstFile = pod.getPdfFilesWithFolderId(folder.folderId).filter((f:MaterialListType) => ( !pod.nodeIsHiddenForThisUser(f.id) ) )[0]
        return <MenuItem selected={folder.folderId === pod?.content.pdfFiles[nodeId].folderId} onClick={() => { navigate(`/pod/${podId}/pdf/${firstFile.file?.nodeId}`); handleFolderMenuClose()}} disabled={!firstFile}>
          <ListItemIcon>
            {folder.folderId === pod?.content.pdfFiles[nodeId].folderId ? <FolderOpen fontSize="small" /> : <FolderOutlined fontSize="small" />}
          </ListItemIcon>
          <ListItemText>{folder.name}</ListItemText>
        </MenuItem>})
      }
    </Menu>


    return <Box sx={{
      display:'grid',
      gridTemplateColumns:"min-content min-content max-content",
      alignItems:'center',
      whiteSpace:'nowrap',
      textTransform:'none',
      overflow:'hidden',
    }}>
      {folderButton}
      <ArrowRightOutlined sx={{verticalAlign:'bottom'}} />
      <Button sx={buttonStyle} startIcon={<DescriptionOutlined />} onClick={(event) => {setFileMenuAnchorEl(event.currentTarget)}}>{pod?.content.pdfFiles[nodeId].name}</Button>
      {fileMenu}
      {folderMenu}
    </Box>
  }
  return null
}

const SidebarContainer = ({children}: {children: ReactNode}) => {
  const { t } = useTranslation()
  const { uiStore } = useStore()
  const { podId, tab } = useParams()
  const deviceWidth = uiStore.deviceWidth
  const sidebarIsOpen = uiStore.sidebarIsOpen
  const headerHeight = uiStore.headerHeight
  const smallScreen = deviceWidth === "tiny" || deviceWidth === "smaller" || deviceWidth === "small" || deviceWidth === "medium"
  const maxPageWidth = uiStore.maxPageWidth

  function toggleSidebarOpen() {
    uiStore.toggleSidebarIsOpen()
  }

  function handleSidebarClose() {
    uiStore.setSidebarIsOpen(false)
  }

  function navigateBackward() {
    if (window.history.state) {
      window.history.back()
    }
  }

  const handlers = useSwipeable({
    onSwipedLeft: handleSidebarClose,
  })

  const Header = () => (
    <Box sx={{
      justifySelf: "center",
      maxWidth: `${maxPageWidth}px`,
      width: "100%",
      alignContent: "center",
      alignItems: "center",
      backgroundColor: smallScreen ? "primary.main" : "back.main",
      display: "grid",
      gridTemplateColumns: smallScreen ? "max-content max-content auto max-content" : "auto max-content",
      gridTemplateRows: "auto",
      height: `${headerHeight}px`,
      padding: "0 25px"
    }}>
      {smallScreen === true &&
        <>
          <SidebarDrawer />
          <Button
            disabled={!window.history.state}
            onClick={navigateBackward}
            size="small"
            sx={{color: smallScreen ? "whitesmoke" : "primary.main"}}
            title={t('Back')||''}
          >
            <ArrowBack />
          </Button>
        </>
      }
      <PdfPath />
      <Box sx={{textAlign:'right'}}>
        <SyncStatus style={{backgroundColor:'#eee'}} />
        <Search />
        <AccountButton />
      </Box>

    </Box>
  )

  const SidebarDrawer = () => (
      <Box>
        <Button
          onClick={toggleSidebarOpen}
          size="small"
          variant="classic"
        >
          {sidebarIsOpen ?
            <MenuOpenIcon sx={{fontSize: "20px"}} />
            :
            <MenuIcon sx={{fontSize: "20px"}} />
          }
        </Button>
        <Drawer
          anchor={"left"}
          open={sidebarIsOpen}
          onClose={handleSidebarClose}
          {...handlers}
          transitionDuration={{ appear: 100, enter: 100, exit: 100 }}
          sx={{
            marginTop: `${headerHeight}px`,
            '&.MuiDrawer-root .MuiModal-backdrop': { position: "absolute" },
            '&.MuiDrawer-root .MuiDrawer-paper': { marginTop: `${headerHeight}px`, height: `calc(100% - ${headerHeight}px)` },
          }}
        >
          <Sidebar />
        </Drawer>
      </Box>
  )

  if(smallScreen) return (
    <Box sx={{display: "grid", gridTemplateRows: "max-content auto", height: "100dvh"}}>
      <Header />
      {children}
    </Box>
  )

  return (
    <Box sx={{
      backgroundColor: "back.main",
      display: "grid",
      gridTemplateColumns: `max-content minmax(auto, ${maxPageWidth}px)`,
      height: "100dvh",
      justifyContent: "center",
      overflowY: "auto"
    }}>
      <Sidebar />
      <Box sx={{display: "grid", gridTemplateRows: "max-content auto", overflowY: "auto"}}>
        <Box sx={{padding: "15px 45px 0 45px"}}>
          {(podId === undefined || tab === "pdf")   ?
            <Header />
            :
            <Box sx={{
              margin: "0 15px"
            }}>
              <PodImageHeader>
                <SyncStatus />
                <Search />
                <AccountButton />
              </PodImageHeader>
            </Box>
          }
        </Box>
        {children}
      </Box>
    </Box>
  )

}

export default observer(SidebarContainer)